import React from "react";
import styled from "styled-components";
import InforCircleIcon from "../assets/info-circle-icon";
import { buildTestID } from "../Utils/utils";

const StyledInsuranceClaimBanner = styled.div`
  align-items: center;
  background-color: #475468;
  border-radius: 20px;
  display: inline-flex;
  flex-direction: column;
  padding: 14px 18px;
  position: relative;
  

  a {
    color: #000;
  }

  & .div {
    align-items: center;
    display: inline-flex;
    flex: 0 0 auto;
    gap: 10px;
    position: relative;
  }

  & .group {
    height: 24px;
    position: relative;
    width: 24px;
  }

  & .vector {
    height: 19px;
    left: 2px;
    position: absolute;
    top: 2px;
    width: 19px;
  }

  & .text-wrapper {
    color: #ffffff;
    font-family: "Lato-Bold", Helvetica;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 22px;
    position: relative;
    width: fit-content;
    margin-bottom: 0;
  }

  & .div-wrapper {
    align-items: center;
    background-color: #ffffff;
    border: 1px solid;
    border-radius: 10px;
    display: inline-flex;
    flex: 0 0 auto;
    gap: 10px;
    justify-content: center;
    padding: 8px 16px;
    position: relative;
    margin: 12px 0 4px;
  }

  & .text-wrapper-2 {
    color: #475468;
    font-family: "Lato-Bold", Helvetica;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: normal;
    margin-top: -1px;
    position: relative;
    text-align: center;
    width: fit-content;
  }

  @media (min-width: 1281px) {
    flex-direction: row;
    justify-content: center;
    height: 51px;

    & .div {
      margin-right: 20px;
    }

    & .text-wrapper {
      white-space: nowrap;
    }
  }
`;

export const InsuranceClaimBanner = () => {
  return (
    <StyledInsuranceClaimBanner>
      <div className="div">
        <div className="group">
          <InforCircleIcon color="white" />
        </div>
        <p className="text-wrapper">Insurance Claim/Loss Draft: Has your property been damaged?</p>
      </div>
      <div className="div-wrapper">
        <div className="text-wrapper-2"><a href="https://www.reversedepartment.com/claims" target="_blank" rel="noreferrer" data-testid={buildTestID('libor-modal',
                    '/',
                    'libor-banner')}>Click Here</a></div>
      </div>
    </StyledInsuranceClaimBanner>
  );
};
